import { forwardRef, ReactElement } from 'react';

import * as Styled from './Loading.styles';
import { ILoadingProps } from './Loading.types';

const Loading = forwardRef<SVGSVGElement, ILoadingProps>(
  ({ size = 'normal', type = 'default', ...rest }, ref): ReactElement => (
    <Styled.Container aria-label="Loading spinner" size={size} viewBox="-2 -2 36 36" ref={ref} {...rest}>
      <Styled.Background size={size} r="16" cx="16" cy="16" />
      <Styled.Highlighted size={size} type={type} r="16" cx="16" cy="16" />
    </Styled.Container>
  ),
);

export default Loading;
